// 상수 및 공통함수
const cmm = {};

//API 서버 PATH
cmm.AUTH_SERVER_API_URL = 'https://auth.theklab.co.kr';

//API 서버 PATH
cmm.SERVER_API_URL = 'https://backend.saleslog.co.kr';
cmm.SERVER_API_URL_TEST = 'http://localhost:5526';

//업로드 파일경로 (영업일지,고객,고객담당자)
cmm.FILE_PATH_FILES = '/files/';

//업로드 파일경로 (회원사진)
cmm.FILE_PATH_PHOTOS = '/photo/';

// client_id
cmm.CLIENT_ID = 'saleslog.co';

// client secret
cmm.CLIENT_SECRET = '8fba114f8291cf28e443c30aba7cce86';


//빈값 체크
cmm.isEmpty = (data) => {
  if (data === undefined || data === null || data === '') {
    return true;
  } else {
    return false;
  }
}

//콤보박스 선택없음 추가
cmm.selComboList = (v) => {
  let rtn = [];

  rtn[0] = { value: '', label: '선택없음' };
  for (let i = 0; i < v.length; i++) {
    rtn[i + 1] = { value: v[i].dept_idx, label: v[i].dept_name };
  }
  return rtn;
}

// 니즈분류 데이터 추가
cmm.setDataList = (v) => {
  let result = [];
  for (let i = 0; i < v.length; i++) {
    result[i] = { id: v[i].needs_cod, label: v[i].needs_cod, value: v[i].total, needslog: v[i].needs, percent: v[i].percent }
  }
  return result;
}

//mobile/pc 체크 
cmm.getPlatform = () => {
  // console.log(navigator.userAgent)
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone|webview/i.test(navigator.userAgent)) {
    return 'mobile';
  } else {
    return 'pc';
  }
}

// webview 체크 
cmm.getWebview = () => {
  // console.log(navigator.userAgent)
  if (/webview/i.test(navigator.userAgent)) {
    return 'webview';
  } else {
    return 'web';
  }
}



//windows screen size
cmm.windowSize = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
}

//permission
cmm.permission = (data) => {
  switch (data) {
    case '0':
      return 'Master';
    case '1':
      return 'Chief';
    case '2':
      return 'Manager';
    case '9':
      return 'Staff';
    case '-1000':
      return 'TheKlab Admin';
    default:
      return 'Staff';
  }
}

// pad (string 0 채움)
cmm.pad = (number, length) => {
  let str = '' + number;
  while(str.length < length) {
    str = '0' + str;
  } 
  return str;
}

// 날짜 포맷 (yyyymmddhhnnss)
cmm.yyyymmddhhnnss = (nowDate) => {
  return nowDate.getFullYear().toString() 
        + cmm.pad(nowDate.getMonth() + 1,2)
        + cmm.pad(nowDate.getDate(),2) 
        + cmm.pad(nowDate.getHours(),2) 
        + cmm.pad(nowDate.getMinutes(),2)
        + cmm.pad(nowDate.getSeconds(),2);
}


cmm.dashboardChartColors = //['#398FFF']
  // ['#142459', '#176ba0', '#19aade', '#1ac9e6', '#1de4bd', '#60f0d2', '#c7f9ee']
  ['#142459', '#176ba0', '#19aade', '#1ac9e6', '#1de4bd', '#60f0d2', '#c7f9ee']

cmm.needsChartColors = //['#ff9900', '#003300', '#0033cc', '#9933ff']
 ['#04C4D9', '#C2EDF2', '#4AD988', '#F2C641']


module.exports = cmm;